import { useRef, useState, useEffect, useMemo } from 'react';
import InputBox from '../../../component/InputBox';

import SelectionBox from '../../../component/SelectionBox';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import ExcelDownloadButtonBox from '../../../component/buttons/ExcelDownloadButtonBox';
import EnrolmentStatusSubjectModal from '../../modal/EnrolmentStatusSubjectModal';
import { modalType } from '../../../util/ModalUtil';
import ModalRef from '../../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import {
    actionExcelDownload,
    actionSearch,
} from '../../../module/body/semester/SemesterStudentEnrolmentCheckViewTab2BodyModule';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import { handleControl, defaultGridData, initGrid } from '../../../module/component/TableBoxModule';
import TableBox from '../../../component/TableBox';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import { IconButton, Tooltip } from '@material-ui/core';
import PathUtil from '../../../util/PathUtil';
import FormatUtil from '../../../util/FormatUtil';

import qs from 'qs';
import { useLocation } from 'react-router-dom';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PopupRef from '../../../component/PopupRef';

const ConditionArea = ({ tabNo, popupRef, modalRef }) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const dispatch = useDispatch();
    const mainUniversityCd = AuthenticationUtil.getUserUniversityCd();
    const [userUniversityCd, setUserUniversityCd] = useState('');
    const [semesterId, setSemesterId] = useState('');
    const [lessonUniversityCd, setLessonUniversityCd] = useState('');
    const [subjectNm, setSubjectNm] = useState('');
    const [userNm, setUserNm] = useState('');
    const [enrolmentValidStatusCd, setEnrolmentValidStatusCd] = useState('');
    const [params, setParams] = useState({});

    const { gridData } = useSelector((state) => state.tableBoxState);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );

        queryData.semesterId == undefined
            ? setSemesterId(SessionStorageUtil.getCurrentSemesterId())
            : setSemesterId(queryData.semesterId);
        queryData.lessonUniversityCd && setLessonUniversityCd(queryData.lessonUniversityCd);
        queryData.enrolmentValidStatusCd && setEnrolmentValidStatusCd(queryData.enrolmentValidStatusCd);
        queryData.subjectNm && setSubjectNm(queryData.subjectNm);
        queryData.userNm && setUserNm(queryData.userNm);

        onClick({
            semesterId:
                queryData.semesterId == undefined ? SessionStorageUtil.getCurrentSemesterId() : queryData.semesterId,
            mainUniversityCd,
            userUniversityCd,
            lessonUniversityCd: queryData.lessonUniversityCd,
            enrolmentValidStatusCd: queryData.enrolmentValidStatusCd,
            subjectNm: queryData.subjectNm,
            userNm: queryData.userNm,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 100,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onRowDoubleClick,
                onChangePageInfo,
                params,
            }),
        );
    }, [params]);

    const onChangePageInfo = (page, pageSize) => {
        onClick({
            ...params,
            page,
            pageSize,
        });
    };

    const onClick = (params) => {
        setParams(params);
        dispatch(
            actionSearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, { ...params, tabNo });
    };

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <EnrolmentStatusSubjectModal
                row={row}
                type={modalType.DETAIL}
                modalRef={modalRef}
                callback={() => {
                    onClick(params);
                }}
            />,
            'medium',
        );
    };

    const handleDownload = () => {
        dispatch(actionExcelDownload({ params }));
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClick({
                semesterId,
                mainUniversityCd,
                userUniversityCd,
                lessonUniversityCd,
                subjectNm,
                userNm,
                enrolmentValidStatusCd,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const columns = useMemo(
        () => [
            {
                field: 'lessonUniversityNm',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'subjectNm',
                headerName: '개설대학교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 5 },
            {
                field: 'profNm',
                headerName: '교강사',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 5 },

            {
                field: 'userUniversityCd',
                headerName: '소속대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, params.row.userUniversityCd),
            },

            {
                field: 'majorDeptNm',
                headerName: '소속대학 전공(학과)',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'studentId',
                headerName: '소속대학 학번',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userNm',
                headerName: '이름',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'userId',
                headerName: '사용자ID',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'telNo',
                headerName: '연락처',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => FormatUtil.phoneFormatter(params.row.telNo),
            },
            {
                field: 'enrolmentRegDttm',
                headerName: '수강신청일시',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'enrolmentValidStatusCd',
                headerName: '본교수강자격검증',
                headerAlign: 'center',
                align: 'center',
                // tooltip: true,
                flex: 10,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_VALID_STATUS}
                        statusCd={params.row.enrolmentValidStatusCd}
                    />
                ),
                // CodeUtil.getCodeName(CODE_GROUP_ID.ENROLMENT_VALID_STATUS, params.row.enrolmentValidStatusCd),
            },
            {
                field: 'enrolmentRegStatusCd',
                headerName: '수강신청 등록상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={params.row.enrolmentRegStatusCd}
                    />
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 5,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <div className='tab-body'>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => setSemesterId(e.target.value)}
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='소속대학'
                                    w140
                                    value={userUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                    onChange={(e) => setUserUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='본교수강자격검증'
                                    w140
                                    value={enrolmentValidStatusCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_VALID_STATUS)}
                                    onChange={(e) => setEnrolmentValidStatusCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='이름'
                                    value={userNm}
                                    onChange={(e) => setUserNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                    size='medium'
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClick({
                                            semesterId,
                                            mainUniversityCd,
                                            userUniversityCd,
                                            lessonUniversityCd,
                                            subjectNm,
                                            userNm,
                                            enrolmentValidStatusCd,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='con-tb-wrap'>
                <div className='con-tb-title  '>
                    <h3 className='tb-tit-name'>본교생 학점교류 신청현황 목록</h3>
                    <div className='btn-group'>
                        <ExcelDownloadButtonBox onClick={(e) => handleDownload()} />
                    </div>
                </div>
                <div className='comment-box'>
                    <ul>
                        <li>본교생의 과목별 수강신청 현황을 확인할 수 있습니다.</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

const SemesterStudentEnrolmentCheckViewTab2Body = ({ tabNo }) => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);

    return (
        <div>
            <ConditionArea tabNo={tabNo} popupRef={popupRef} modalRef={modalRef} />
            <TableBox />
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </div>
    );
};

export default SemesterStudentEnrolmentCheckViewTab2Body;
